// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2YzKC","errorLogs":"styles_errorLogs__hHPW2"};